export default __webpack_public_path__ + "static/media/minus.244e364b.svg";